import { forwardRef } from "react";
import { Icon, type LucideProps } from "lucide-react";
import { baseball } from "@lucide/lab";

export const BaseballIcon = forwardRef<SVGSVGElement, LucideProps>(
  ({ className, ...props }, ref) => (
    <Icon ref={ref} iconNode={baseball} className={className} {...props} />
  ),
);
BaseballIcon.displayName = "BaseballIcon";
